import React, { useState, useEffect } from 'react';
import PostCard from '../components/PostCard';
import Carousel from '../components/Carousel';
import { postsAPI, carouselAPI } from '../services/api';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [carouselItems, setCarouselItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [postsResponse, carouselResponse] = await Promise.all([
        postsAPI.getAll(),
        carouselAPI.getAll()
      ]);
      setPosts(postsResponse.data);
      setCarouselItems(carouselResponse.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white text-xl">Loading ISMP content...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-red-500 to-red-700 bg-clip-text text-transparent mb-4">
            Welcome to ISMP
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Inside Survival Multiplayer - Where global communities unite in the world of Minecraft
          </p>
        </div>

        {/* Carousel/Notice Board */}
        <Carousel items={carouselItems} />

        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-8 h-8 bg-gradient-to-r from-red-600 to-red-800 rounded-full"></div>
            <h2 className="text-2xl font-bold text-white">Latest Updates</h2>
          </div>
          
          <div className="space-y-6">
            {posts.length > 0 ? (
              posts.map((post) => (
                <PostCard key={post.id} post={post} />
              ))
            ) : (
              <div className="text-center py-12">
                <div className="bg-gradient-to-r from-gray-800/50 to-gray-700/50 rounded-2xl p-8 border border-gray-600/30 backdrop-blur-sm">
                  <h3 className="text-xl font-bold text-white mb-2">No posts yet</h3>
                  <p className="text-gray-400">
                    Check back soon for the latest server updates and announcements!
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;